import { acquirePageScrollLock } from './scroll_lock.js';

let _releaseZoomModalScrollLock = null;

export function toggleModal(show) {
    const el = document.getElementById('zoomModal');
    const zoomImg = document.getElementById('zoomModalImg');
    const tooltip = document.getElementById('xrayTooltip');

    const addInspectFlag = (rawUrl) => {
        if (!rawUrl) return rawUrl;
        const joiner = rawUrl.includes('?') ? '&' : '?';
        return `${rawUrl}${joiner}inspect=1`;
    };

    if(show) {
        if (!_releaseZoomModalScrollLock) {
            _releaseZoomModalScrollLock = acquirePageScrollLock();
        }
        const baseUrl = document.getElementById('resImg').dataset.inspectUrl || document.getElementById('resImg').src;
        zoomImg.src = addInspectFlag(baseUrl);
        el.style.display = 'flex';
        el.classList.remove('hidden');
        if (zoomImg.complete) {
            document.dispatchEvent(new Event('resetZoom'));
        } else {
            zoomImg.onload = () => document.dispatchEvent(new Event('resetZoom'));
        }
    } else {
        if (_releaseZoomModalScrollLock) {
            _releaseZoomModalScrollLock();
            _releaseZoomModalScrollLock = null;
        }
        el.classList.add('hidden');
        el.style.display = 'none';
        if(tooltip) tooltip.classList.add('hidden');
    }
}
